import { render, staticRenderFns } from "./LiveController.vue?vue&type=template&id=589ab586&scoped=true"
import script from "./LiveController.vue?vue&type=script&lang=js"
export * from "./LiveController.vue?vue&type=script&lang=js"
import style0 from "./LiveController.vue?vue&type=style&index=0&id=589ab586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589ab586",
  null
  
)

export default component.exports